(function () {
    'use strict';

    var CIRCUMFERENCE = 327;

    function prefersReducedMotion() {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function track(root, name, payload) {
      if (root.getAttribute('data-track') !== 'true') return;
      var detail = payload || {};
      detail.section = root.getAttribute('data-sb-system-guide');

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name }, detail));
      document.dispatchEvent(new CustomEvent(name, { detail: detail }));
    }

    function SmoocheSystemGuide(root) {
      this.root = root;
      this.radios = Array.prototype.slice.call(root.querySelectorAll('[data-sb-radio]'));
      this.rings = Array.prototype.slice.call(root.querySelectorAll('[data-sb-stat]'));
      this.videos = Array.prototype.slice.call(root.querySelectorAll('[data-sb-video]'));
      this.carousels = Array.prototype.slice.call(root.querySelectorAll('[data-sb-carousel]'));
      this.scrollMarks = [25, 50, 75, 100];
      this.init();
    }

    SmoocheSystemGuide.prototype.init = function () {
      this.bindChooser();
      this.bindDeepLink();
      this.bindRings();
      this.bindCarousels();
      this.bindTimelines();
      this.bindVideos();
      this.syncVideos();
      this.bindScrollDepth();
    };


    SmoocheSystemGuide.prototype.activeGuide = function () {
      for (var i = 0; i < this.radios.length; i++) {
        if (this.radios[i].checked) return this.radios[i].getAttribute('data-guide');
      }
      return null;
    };

    SmoocheSystemGuide.prototype.bindChooser = function () {
      var self = this;

      this.radios.forEach(function (radio) {
        radio.addEventListener('change', function () {
          if (!radio.checked) return;
          var guide = radio.getAttribute('data-guide');

          if (window.history && window.history.replaceState) {
            window.history.replaceState(null, '', '#' + guide);
          }

          self.resetRings();
          self.syncCarousels();
          self.syncVideos();
          window.requestAnimationFrame(function () {
            self.syncTimelines();
          });
          track(self.root, 'sb_howto_guide_open', { guide: guide });
        });
      });
    };


    SmoocheSystemGuide.prototype.selectGuide = function (key, scroll) {
      if (!key) return false;
      var wanted = String(key).toLowerCase();

      for (var i = 0; i < this.radios.length; i++) {
        if (this.radios[i].getAttribute('data-guide') !== wanted) continue;
        if (!this.radios[i].checked) {
          this.radios[i].checked = true;
          this.radios[i].dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (scroll) {
          var chooser = this.root.querySelector('.sb-system-guide__chooser');
          if (chooser && chooser.scrollIntoView) {
            chooser.scrollIntoView({
              behavior: prefersReducedMotion() ? 'auto' : 'smooth',
              block: 'start'
            });
          }
        }
        return true;
      }
      return false;
    };

    SmoocheSystemGuide.prototype.keyFromUrl = function () {
      var hash = (window.location.hash || '').replace('#', '');
      if (hash) return hash;
      try {
        return new URLSearchParams(window.location.search).get('guide') || '';
      } catch (e) {
        return '';
      }
    };

    SmoocheSystemGuide.prototype.bindDeepLink = function () {
      var self = this;


      this.selectGuide(this.keyFromUrl(), true);

      window.addEventListener('hashchange', function () {
        self.selectGuide(self.keyFromUrl(), true);
      });
    };


    SmoocheSystemGuide.prototype.fillRing = function (ring) {
      var bar = ring.querySelector('.sb-system-guide__stat-fill');
      if (bar) {
        bar.style.width = ring.getAttribute('data-pct') + '%';
        return;
      }
      var circle = ring.querySelector('.sb-system-guide__ring-value');
      if (!circle) return;
      circle.style.strokeDashoffset = ring.getAttribute('data-offset');
    };

    SmoocheSystemGuide.prototype.emptyRing = function (ring) {
      var bar = ring.querySelector('.sb-system-guide__stat-fill');
      if (bar) {
        bar.style.width = '0%';
        return;
      }
      var circle = ring.querySelector('.sb-system-guide__ring-value');
      if (!circle) return;
      circle.style.strokeDashoffset = CIRCUMFERENCE;
    };

    SmoocheSystemGuide.prototype.bindRings = function () {
      var self = this;


      if (!('IntersectionObserver' in window) || prefersReducedMotion()) return;

      this.rings.forEach(function (ring) {
        self.emptyRing(ring);
      });

      this.observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            self.fillRing(entry.target);
            self.observer.unobserve(entry.target);
          });
        },
        { threshold: 0.35 }
      );

      this.rings.forEach(function (ring) {
        self.observer.observe(ring);
      });
    };

    SmoocheSystemGuide.prototype.resetRings = function () {
      var self = this;
      if (!this.observer) return;

      window.requestAnimationFrame(function () {
        self.rings.forEach(function (ring) {
          if (!ring.offsetParent) return;
          if (ring.getAttribute('data-done') === 'true') return;
          ring.setAttribute('data-done', 'true');
          self.fillRing(ring);
        });
      });
    };


    SmoocheSystemGuide.prototype.bindCarousels = function () {
      var self = this;

      this.carousels.forEach(function (carousel) {
        var track = carousel.querySelector('[data-sb-track]');
        var prev = carousel.querySelector('[data-sb-prev]');
        var next = carousel.querySelector('[data-sb-next]');
        var dotsWrap = carousel.querySelector('[data-sb-dots]');
        if (!track) return;

        var cards = Array.prototype.slice.call(track.children);
        if (!cards.length) return;

        function step() {
          var first = cards[0].getBoundingClientRect().width;
          var gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
          return first + gap;
        }

        function index() {
          var size = step();
          if (!size) return 0;
          return Math.round(track.scrollLeft / size);
        }

        var dots = [];
        if (dotsWrap) {
          cards.forEach(function (card, i) {
            var dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'sb-system-guide__dot';
            dot.setAttribute('aria-label', String(i + 1));
            dot.addEventListener('click', function () {
              track.scrollTo({ left: step() * i, behavior: 'smooth' });
            });
            dotsWrap.appendChild(dot);
            dots.push(dot);
          });
        }

        function sync() {
          var scrollable = track.scrollWidth - track.clientWidth > 1;
          carousel.setAttribute('data-scrollable', scrollable ? 'true' : 'false');

          var i = index();
          dots.forEach(function (dot, n) {
            dot.setAttribute('aria-current', n === i ? 'true' : 'false');
          });
        }



        function move(direction) {
          var max = track.scrollWidth - track.clientWidth;
          if (max <= 1) return;

          if (direction > 0 && track.scrollLeft >= max - 1) {
            track.scrollTo({ left: 0, behavior: 'smooth' });
            return;
          }
          if (direction < 0 && track.scrollLeft <= 1) {
            track.scrollTo({ left: max, behavior: 'smooth' });
            return;
          }
          track.scrollBy({ left: step() * direction, behavior: 'smooth' });
        }

        if (prev) prev.addEventListener('click', function () { move(-1); });
        if (next) next.addEventListener('click', function () { move(1); });

        var ticking = false;
        track.addEventListener(
          'scroll',
          function () {
            if (ticking) return;
            ticking = true;
            window.requestAnimationFrame(function () {
              ticking = false;
              sync();
            });
          },
          { passive: true }
        );

        window.addEventListener('resize', sync);
        carousel.syncCarousel = sync;
        sync();
      });
    };




    var TIMELINE_LINE = 0.7;

    SmoocheSystemGuide.prototype.bindTimelines = function () {
      var self = this;
      this.timelines = Array.prototype.slice.call(this.root.querySelectorAll('[data-sb-timeline]'));
      if (!this.timelines.length) return;


      this.timelineMotion = !prefersReducedMotion();
      if (this.timelineMotion) {
        this.timelines.forEach(function (timeline) {
          timeline.setAttribute('data-armed', '');
        });
      }

      var ticking = false;
      function schedule() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          ticking = false;
          self.syncTimelines();
        });
      }

      window.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule);
      window.addEventListener('load', schedule);
      this.syncTimelines();
    };

    SmoocheSystemGuide.prototype.syncTimelines = function () {
      if (!this.timelines) return;
      var motion = this.timelineMotion;
      var line = window.innerHeight * TIMELINE_LINE;

      this.timelines.forEach(function (timeline) {


        if (timeline.offsetParent === null) return;

        var trackEl = timeline.querySelector('.sb-system-guide__tl-track');
        var rail = timeline.querySelector('[data-sb-tl-rail]');
        var fill = timeline.querySelector('[data-sb-tl-fill]');
        var items = timeline.querySelectorAll('[data-sb-tl-item]');
        var dots = timeline.querySelectorAll('[data-sb-tl-dot]');
        if (!trackEl || !rail || !dots.length) return;

        var top = trackEl.getBoundingClientRect().top;
        var centres = [];
        for (var i = 0; i < dots.length; i++) {
          var box = dots[i].getBoundingClientRect();
          centres.push(box.top + box.height / 2);
        }

        var first = centres[0];
        var length = Math.max(centres[centres.length - 1] - first, 0);
        rail.style.top = first - top + 'px';
        rail.style.bottom = 'auto';
        rail.style.height = length + 'px';

        if (!motion) return;

        if (fill) fill.style.height = Math.min(Math.max(line - first, 0), length) + 'px';

        for (var n = 0; n < items.length; n++) {
          items[n].classList.toggle('is-on', centres[n] <= line + 0.5);
        }
      });
    };

    SmoocheSystemGuide.prototype.syncVideos = function () {
      var self = this;
      if (prefersReducedMotion()) return;

      window.requestAnimationFrame(function () {
        self.videos.forEach(function (video) {
          if (!video.hasAttribute('data-sb-gif')) return;
          if (video.offsetParent === null) {
            video.pause();
            return;
          }
          var started = video.play();
          if (started && started.catch) {
            started.catch(function () {});
          }
        });
      });
    };

    SmoocheSystemGuide.prototype.syncCarousels = function () {
      var self = this;
      window.requestAnimationFrame(function () {
        self.carousels.forEach(function (carousel) {
          if (typeof carousel.syncCarousel === 'function') carousel.syncCarousel();
        });
      });
    };


    SmoocheSystemGuide.prototype.bindVideos = function () {
      var self = this;

      this.videos.forEach(function (video) {
        var guide = video.getAttribute('data-guide');
        var isGif = video.hasAttribute('data-sb-gif');
        var wrap = video.parentNode;
        var play = wrap ? wrap.querySelector('[data-sb-play]') : null;
        var seen = {};


        video.addEventListener('playing', function () {
          if (wrap) wrap.setAttribute('data-playing', 'true');
          if (play) play.hidden = true;
        });

        if (play) {
          play.hidden = false;
          play.addEventListener('click', function () {
            if (!isGif) video.controls = true;
            var started = video.play();
            if (started && started.catch) {
              started.catch(function () {
                play.hidden = false;
              });
            }
          });
        }

        if (isGif) {

          if (prefersReducedMotion()) {
            video.removeAttribute('autoplay');
            video.controls = true;
            video.pause();
            return;
          }


          if ('IntersectionObserver' in window) {
            var io = new IntersectionObserver(
              function (entries) {
                entries.forEach(function (entry) {
                  if (entry.isIntersecting && entry.target.offsetParent !== null) {
                    var started = entry.target.play();
                    if (started && started.catch) {
                      started.catch(function () {});
                    }
                  } else {
                    entry.target.pause();
                  }
                });
              },
              { threshold: 0.25 }
            );
            io.observe(video);
          }


          return;
        }

        if (play) video.removeAttribute('controls');

        video.addEventListener('play', function () {
          track(self.root, 'sb_howto_video_play', { guide: guide });
        });

        video.addEventListener('timeupdate', function () {
          if (!video.duration || !isFinite(video.duration)) return;
          var pct = Math.floor((video.currentTime / video.duration) * 100);

          [25, 50, 75, 95].forEach(function (mark) {
            if (pct < mark || seen[mark]) return;
            seen[mark] = true;
            track(self.root, 'sb_howto_video_progress', {
              guide: guide,
              percent: mark === 95 ? 100 : mark
            });
          });
        });

        video.addEventListener('ended', function () {
          video.controls = false;
          video.load();
          if (wrap) wrap.removeAttribute('data-playing');
          if (play) play.hidden = false;
        });
      });
    };


    SmoocheSystemGuide.prototype.bindScrollDepth = function () {
      var self = this;
      var seen = {};
      var ticking = false;

      function measure() {
        ticking = false;
        var box = self.root.getBoundingClientRect();
        var total = box.height - window.innerHeight;
        if (total <= 0) return;

        var pct = Math.round((-box.top / total) * 100);
        if (pct < 0) return;

        self.scrollMarks.forEach(function (mark) {
          if (pct < mark || seen[mark]) return;
          seen[mark] = true;
          track(self.root, 'sb_howto_scroll_depth', { percent: mark });
        });
      }

      window.addEventListener(
        'scroll',
        function () {
          if (ticking) return;
          ticking = true;
          window.requestAnimationFrame(measure);
        },
        { passive: true }
      );
    };


    function boot(scope) {
      var roots = (scope || document).querySelectorAll('[data-sb-system-guide]');
      Array.prototype.forEach.call(roots, function (root) {
        if (root.hasAttribute('data-sb-ready')) return;
        root.setAttribute('data-sb-ready', 'true');
        new SmoocheSystemGuide(root);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        boot(document);
      });
    } else {
      boot(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      boot(event.target);
    });
  })();
